module.exports = __webpack_public_path__ + "img/photo-upload.c4b367fb.svg";